// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-control[data-v-52e6535c] {\n  width: 20px;\n  height: 20px;\n  border: none;\n  border-radius: 50%;\n  box-shadow: none;\n  background: #fc6836;\n  font-size: 21px;\n  line-height: 21px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
